import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import AppContext from "../../../../context/AppContext";
import CrmViewer from "../crmViewer/CrmViewer";
import { Link } from "react-router-dom";
import ArrowSm from "../../../../components/atoms/icons/general/arrowSm/ArrowSm";
import CrmStats from "../crmStats/CrmStats";

function CrmMainPage({ isNetwork, isAgency }) {
  const { tabParam, networkParam, agencyParam } = useParams();
  const { setBannerConfig, setBreadcrumbsSpecialValue } = useContext(AppContext);

  useEffect(() => {
    const backLink = getBackLink();
    const pageTitle =
      tabParam === "faq" ? "F.A.Q." : tabParam.replaceAll("-", " ").replace(/^\w/, c => c.toUpperCase());

    setBannerConfig({
      title: <>CRM - {pageTitle}</>,
      subtitle: (
        <Link to={backLink} className='link-with-arrow'>
          <ArrowSm />
          Retour au menu
        </Link>
      ),
      className: "crm-banner",
    });

    if (isNetwork) setBreadcrumbsSpecialValue({ to: networkParam ?? agencyParam });
  }, [tabParam]);

  function getBackLink() {
    return "/admin/crm" + (isNetwork ? "/reseau" : isAgency ? "/agence" : "");
  }

  return (
    <>
      {(tabParam === "utilisateurs" || tabParam === "estimations") && (
        <CrmViewer isAgency={isAgency} isNetwork={isNetwork} />
      )}
      {tabParam === "statistiques" && <CrmStats isAgency={isAgency} isNetwork={isNetwork} />}
    </>
  );
}

export default CrmMainPage;
